const getColumnClass = (cols) => {
  return `col-xs-${cols} col-sm-${cols} col-md-${cols} col-lg-${cols} col-xl-${cols}`
}

export const getColumnClasses = (mainCols) => {
  return [getColumnClass(mainCols), getColumnClass(12 - mainCols)]
}